module.exports = __webpack_public_path__ + "animoji4.190e20e765.png";